import React from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import _ from 'lodash'
import * as routes from 'core/routing/constants/index'
import { Row, Col } from 'core/components/ui'
import wizardsShape from 'core/components/wizard/shapes'
import { font, greys, borderRadius } from 'assets/themes/theme-default'
import { brandShape, configuratorShape } from '../../shapes'

const BrandWrapper = styled(Col)`
  height: 70px;
  margin-bottom: 15px;
  cursor: pointer;
`

const NameWrapper = styled(Row)`
  &&& {
    padding: 0 5px;
    width: 100%;
    height: 100%;
    color: ${greys.dark1};
    font-size: ${font.size.lg};
    font-weight: ${font.weight.bold};
    text-transform: uppercase;
    border-radius: ${borderRadius.base};
    border: 2px solid ${greys.dark1};
    cursor: pointer;
    span {
      text-align: center;
    }
    &.isSelected,
    :hover {
      border-color: ${props => props.theme.colors.color1.bg};
      background: ${props => props.theme.colors.color1.bg};
      color: ${greys.light4};
    }
  }
`

const BrandItem = props => {
  const { history, wizards, setWizards, setConfigurator, configurator, brand } = props

  const activateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_BRANDS) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })
    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)

    history.push(extendedStep.hash)
  }

  const desactivateNextSteps = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const currentIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_BRANDS)

    const steps = aStepsActive.map((step, index) => {
      let returnedStep = step
      if (index > currentIndex) returnedStep = { ...step, isActive: false }

      return returnedStep
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: steps }

    setWizards(extentedWizards)
  }

  const handleClick = async () => {
    const modelGroup = _.isEqual(brand, configurator.brand) ? configurator.modelGroup : null

    const modelsGroupList = _.isEqual(brand, configurator.brand)
      ? configurator.modelsGroupList
      : null

    if (!_.isEqual(brand, configurator.brand)) await desactivateNextSteps()

    const extentedConfiguraor = { ...configurator, brand, modelGroup, modelsGroupList }
    setConfigurator(extentedConfiguraor)

    activateNextStep()
  }

  const isSelected = _.isEqual(brand, configurator.brand) ? 'isSelected' : null

  return (
    <BrandWrapper
      lg={4}
      md={8}
      sm={12}
      xs={24}
      onClick={handleClick}
      data-test="component-configurator-brand-item"
    >
      <NameWrapper
        type="flex"
        justify="center"
        align="middle"
        logo={brand.logo}
        data-test="configurator-brand-item-nameWrapper"
        className={isSelected}
      >
        <span>{brand.name}</span>
      </NameWrapper>
    </BrandWrapper>
  )
}

BrandItem.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  brand: brandShape.isRequired,
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired
}

export default withRouter(BrandItem)
